<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <div class="card-body">
            <AppAlertNote v-if="canEdit">The organization's address is retrieved from their assigned building. If their
                address is blank, assign them to a building, suite and a room number if applicable.
            </AppAlertNote>

            <OrganizationAddressRow :address="businessAddress"
                                    :building-list="buildingList"
                                    :organization-id="organizationId"></OrganizationAddressRow>
            <OrganizationAddressRow :address="mailingAddress"
                                    :building-list="buildingList"
                                    :organization-id="organizationId"></OrganizationAddressRow>
        </div>
        <div class="card-footer d-print-none text-right">
            <RouterLink :to="{name:'Organizations'}" class="btn btn-danger">Back</RouterLink>
        </div>
    </AppLoadingContainer>
</template>

<script>
    import AddressService from "../../services/AddressService";
    import AppAlertNote from "@/components/shared/AppAlertNote";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import OrganizationAddressRow from "@/components/organizations/OrganizationAddressRow";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            OrganizationAddressRow,
            AppAlertNote,
            AppLoadingContainer,
        },
        data() {
            return {
                buildingList: [],
                isLoaded: false,
                businessAddress: {},
                mailingAddress: {}
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true,
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Facilities);
            }
        },
        created() {
            const vm = this;

            Promise.all([
                AddressService.getOrganizationAddresses(vm.organizationId)
                    .then(response => {
                        const addresses = response;

                        vm.businessAddress = addresses.find(el => el.addressType === 'Business');
                        vm.mailingAddress = addresses.find(el => el.addressType === 'Routine Mail');

                        // Note: We are adding "Missing" address types
                        if (!vm.mailingAddress)
                            vm.mailingAddress = {
                                addressType: 'Routine Mail',
                                buildingId: null,
                                suite: null,
                                roomNumber: null,
                            };

                        if (!vm.businessAddress)
                            vm.businessAddress = {
                                addressType: 'Business',
                                buildingId: null,
                                suite: null,
                                roomNumber: null,
                            };

                        vm.businessAddress.label = "Business Contact Address";
                        vm.mailingAddress.label = "Mailing Address"
                    }),

                AddressService.getAllBuildings()
                    .then(response => vm.buildingList = response)]).catch(() => {
                vm.redirectToError();
            }).finally(() => vm.isLoaded = true);
        }
    }
</script>
